import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const folderOffersReducer = (state = initialState.document.decision.folderOffers, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FOLDER_OFFERS_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true,
          loaded: false
        }
      };
    }
    case actionTypes.LOAD_FOLDER_OFFERS_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }

    case actionTypes.LOAD_FOLDER_OFFERS_FAILED: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }

    default:
      return state;
  }
};

export default folderOffersReducer;
